import React from 'react'
import "../../../styles/registrado/CapacitacionesInfo.css"

function CapacitacionesInfo() {
  return (
    <>
        <div className="colorful-form-capacitaciones">
            <div className="form-group">
                <label className="form-label-capacitaciones">Su opinión es importante para nosotros:</label>
                <p className='form-p-capacitaciones'>Haga Click en el boton de abajo. este lo llevará a una encuesta que se está realizando para conocer sus prioridades
                    al momento de realizar nuestras capacitaciones.</p>
            </div>
            <a 
                className="form-button-capacitaciones" 
                href="https://docs.google.com/forms/d/e/1FAIpQLSe8rBhegh_WRK3RoOZGUOlSzt454dTsGkyCngpk-8a-6gCn_Q/viewform?usp=sf_link" 
                target='blank'>
                Encuesta - Capacitaciones
            </a>
        </div>
    </>
  )
}

export default CapacitacionesInfo